/**
 * Obnova user/štandardnej masky pre CRM nastavenia – local-data (parita ServiceStateList / mntn001 §18).
 */
import { getEffectiveMask } from './effectiveMask';
import {
  applyUserMaskRowToTabulator,
  safeParse,
  sanitizeTabulatorLayoutAttributes,
} from './tabulatorProgressiveLoading';

function clearHeaderFilterForField(table, field) {
  if (!table || field == null) return;
  try {
    table.setHeaderFilterValue?.(field, '', true);
  } catch (_) {}
}

/**
 * @param {object} opts
 * @param {string} opts.pageKey
 * @param {object} opts.state – Redux state
 * @param {object} opts.table – Tabulator instance
 * @param {(saved: object) => object} opts.mergeVisibility
 * @param {(table: object, visibilityMap: object) => void} opts.applyDataColumnVisibilityToTable
 * @param {(vis: object) => void} opts.setColumnsVisible
 * @param {string[]} opts.defaultColumnFields – kľúče DEFAULT_COLUMNS_VISIBLE
 */
export function restoreCrmSetupLocalListMask({
  pageKey,
  state,
  table,
  mergeVisibility,
  applyDataColumnVisibilityToTable,
  setColumnsVisible,
  defaultColumnFields,
}) {
  if (!table) return;
  const effective = getEffectiveMask(pageKey, state);
  if (effective?.type === 'user' && effective.userMask) {
    const m = effective.userMask;
    applyUserMaskRowToTabulator(table, m, {
      setColumnsVisible: (v) => setColumnsVisible(mergeVisibility(v)),
      clearHeaderFiltersWhenEmpty: true,
      applyColumnVisibilityFn: (tbl, jc, setVis) => {
        const merged = mergeVisibility(jc);
        setVis(merged);
        applyDataColumnVisibilityToTable(tbl, merged);
      },
    });
    const merged = mergeVisibility(safeParse(m.columns, {}));
    for (const field of defaultColumnFields) {
      if (merged[field] === false) clearHeaderFilterForField(table, field);
    }
  } else if (effective?.type === 'standard' && effective.standardMask) {
    const m = effective.standardMask;
    const attributes = sanitizeTabulatorLayoutAttributes(safeParse(m.attributes, []));
    const json_columns = safeParse(m.columns, {});
    if (Array.isArray(attributes) && attributes.length > 1) {
      table.setColumnLayout?.(attributes);
    }
    if (json_columns && typeof json_columns === 'object') {
      const merged = mergeVisibility(json_columns);
      setColumnsVisible(merged);
      applyDataColumnVisibilityToTable(table, merged);
    }
  }
}
